export const IgnorePrincipal=(value)=>value===null?false:true